const url='https://chartie.onrender.com/api/v1';

export default url;